import React from 'react';
import { Send } from 'lucide-react';

const TelegramSupport = ({ username, position = 'bottom-right' }) => {
  const defaultUsername = import.meta.env.VITE_TELEGRAM_SUPPORT_USERNAME;
  const finalUsername = username || defaultUsername;
  
  const telegramUrl = finalUsername 
    ? `https://t.me/${finalUsername}`
    : 'https://t.me/'; // Replace with your actual Telegram username or bot

  const positionClasses = {
    'bottom-right': 'bottom-6 right-6',
    'bottom-left': 'bottom-6 left-6',
    'top-right': 'top-6 right-6',
    'top-left': 'top-6 left-6'
  };

  const handleClick = () => {
    window.open(telegramUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <button
      onClick={handleClick}
      className={`fixed ${positionClasses[position]} z-50 bg-[#0088cc] hover:bg-[#0077b5] text-white rounded-full p-4 shadow-lg transition-all duration-300 hover:scale-110 group`}
      title="Contact us on Telegram"
      aria-label="Contact us on Telegram"
    >
      <Send className="w-6 h-6" />
      
      {/* Tooltip */}
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Chat with us on Telegram
      </span>
      
      {/* Notification badge (optional - can be controlled by props) */}
      {/* <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
        !
      </span> */}
    </button>
  );
};

export default TelegramSupport;
